import { GlobalComponent } from "src/app/global-component";
import { SortingModel } from "./sorting-model";

export class PagingInfoModel extends SortingModel {
    pageIndex: any = 0;
    pageSize: any = GlobalComponent.defaultPagingInfo.pageSize; 
}